import { useEffect, useState } from 'react';
import type Lenis from 'lenis';
import './back-to-top.scss';

interface BackToTopProps {
  lenis: Lenis;
}

export function BackToTop({ lenis }: BackToTopProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!lenis) return;

    const handleScroll = (event: any) => {
      const scrollTop = typeof event?.scroll === 'number' ? event.scroll : window.scrollY;
      setVisible(scrollTop > 400);
    };

    lenis.on('scroll', handleScroll);
    handleScroll({ scroll: lenis.scroll ?? 0 });

    return () => {
      lenis.off('scroll', handleScroll);
    };
  }, [lenis]);

  const handleClick = () => {
    lenis.scrollTo(0, {
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
  };

  return (
    <button
      type="button"
      className={`back-to-top ${visible ? 'back-to-top--visible' : ''}`}
      onClick={handleClick}
      aria-label="Back to top"
      title="Back to top"
    >
      <span className="back-to-top__icon" aria-hidden="true">
        <svg width="28" height="18" viewBox="0 0 28 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.17157 16.7279C-0.390524 15.1658 -0.390524 12.6332 1.17157 11.0711L11.0711 1.17157C12.6332 -0.390524 15.1658 -0.390524 16.7279 1.17157C18.29 2.73367 18.29 5.26633 16.7279 6.82843L6.82843 16.7279C5.26633 18.29 2.73367 18.29 1.17157 16.7279Z" fill="var(--fill-low)" />
          <path d="M11.0711 1.17157C12.6332 -0.390524 15.1658 -0.390524 16.7279 1.17157L26.6274 11.0711C28.1895 12.6332 28.1895 15.1658 26.6274 16.7279C25.0653 18.29 22.5326 18.29 20.9706 16.7279L11.0711 6.82843C9.50896 5.26634 9.50897 2.73367 11.0711 1.17157Z" fill="var(--fill-low)" />
        </svg>

      </span>
      <span className="back-to-top__label">Back to top</span>
    </button>
  );
}
